import { useTranslation } from 'react-i18next';
import { type RouterSpecsFragment } from '../../../../api/fragments/RouterSpecs';
import CollapsibleWrapper, { Panel } from '../../../../components/wrappers/CollapsibleWrapper';
import { getTitle, renderViewPanel } from './layouts';

export type LayoutProps = {
    router: RouterSpecsFragment;
};

const Layout = ({ router }: LayoutProps) => {
    const { layout } = router;
    const { t } = useTranslation(['routerDetails']);

    return (
        <CollapsibleWrapper defaultActiveKey={getTitle(t, layout)}>
            <Panel key={getTitle(t, layout)} header={getTitle(t, layout)}>
                {renderViewPanel(layout)}
            </Panel>
        </CollapsibleWrapper>
    );
};

export default Layout;
